import React from 'react';
import 'react-quill/dist/quill.snow.css';

interface RichTextContentProps {
  content: string;
  className?: string;
}

const RichTextContent: React.FC<RichTextContentProps> = ({
  content,
  className = '',
}) => {
  return (
    <div
      className={`ql-editor ${className}`}
      dangerouslySetInnerHTML={{ __html: content || '' }}
      style={{
        padding: 0,
        backgroundColor: 'transparent',
        border: 'none',
      }}
    />
  );
};

export default RichTextContent;
